import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import { reducer, ContactState } from './reducer/contact.reducer'

export interface State {
  contact: ContactState
}

const contactState = createFeatureSelector<ContactState>('contact');

export const contact = createSelector(
  contactState,
  (state: ContactState) => state
);